import AsyncControl from '@/Controls/AsyncControl';
import ComponentManager from '@/Management/ComponentManager';
import TabGroupBoxViewModelType from '@/ViewModels/Controls/TabGroupBoxViewModel';
import TabStripType from '@/Controls/TabStrip2';
import GroupFactory from '@/Factories/GroupFactory';
import * as CoreFrameDTOs from "coreframetypings/dto";
import { DisposeBehavior, ITabGroupFactoryConstructorParameter } from '#/DefaultViewExtensionInterfaces';

export default class TabGroupBox extends AsyncControl {

    private TabStrip = ComponentManager.getControl<typeof TabStripType>('TabStrip2');
    private jQueryControl: JQuery;
    private content: JQuery;
    private tabStrip: TabStripType;

    public constructor(private viewModel: TabGroupBoxViewModelType, private element?: JQuery) {
        super(viewModel, element);
    }

    public async getElementAsync(): Promise<JQuery> {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.jQueryControl = this.element || $('<div></div>');
        this.content = $('<div class="c-content"></div>').appendTo(this.jQueryControl);

        this.applyBindings(this.jQueryControl, {
            controlName: 'tabgroupbox',
            visible: this.viewModel.isVisible,
            loader: this.viewModel.isBusy,
            controlIdent: this.identifier
        });

        await this.viewModel.executeBusilyAsync(async () => {
            const groupsWithIndex = this.viewModel.detailViewGroups.map((g, i) => ({ group: g, index: i }));
            await this.createItemsAsync(groupsWithIndex, ({ group, index }) => this.createGroupAsync(index, group));
            if (this.isDisposed || this.viewModel.isDisposed)
                return;

            if (this.viewModel.tabStrip != null && this.viewModel.isFirstTabGroup === true) {
                this.tabStrip = new this.TabStrip(this.viewModel.tabStrip);
                const tuple = await this.tabStrip.getTupleAsync();

                tuple.control.appendTo(this.content);
            }
        });

        this.widget(null);

        return this.jQueryControl;
    }

    private async createGroupAsync(index: number, g: CoreFrameDTOs.IDetailViewGroupDTO) {
        return GroupFactory.createInstanceAsync<ITabGroupFactoryConstructorParameter>(g, this.viewModel.context, {
            tabStrip: this.viewModel.tabStrip,
            parentTabGroup: this.viewModel,
            tabIndex: index,
            isSummaryViewMode: this.viewModel.isSummaryViewMode,
            detailViewGroup: g,
            parentDetailViewGroup: this.viewModel.detailViewGroup,
            locator: this.viewModel.locator
        });
    }

    protected getDisposeBehavior(): DisposeBehavior {
        return "Asynchronous";
    }
}

ComponentManager.setControl('TabGroupBox', TabGroupBox, 'RADPresentation.HTMLClient.DefaultViewExtensions');